import React, { useState } from 'react'

import { TutorialDialog } from '@features/tutorial'
import TIMELINE_TUTORIAL_ACCESS_IMAGE from '@public/assets/welcome-wizard/timeline-tutorial-access.png'

type TimelineTipsStepProps = {
  onSkip: () => void
}

const TimelineTipsStep = ({ onSkip }: TimelineTipsStepProps) => {
  const [isTutorialOpen, setIsTutorialOpen] = useState(false)

  return (
    <>
      <div className="max-w-[900px]">
        <h2 className="text-lg font-semibold text-black">
          Review captured activities from Timeline Panel
        </h2>
        <p className="mt-3 text-base leading-[1.35] text-[#666]">
          The Timeline Panel displays all activities captured throughout your
          day in chronological order, giving you a complete view of your
          workday. Activities may include:
        </p>
        <ul className="mt-1 list-disc pl-5 text-base leading-[1.35] text-[#666]">
          <li>Emails</li>
          <li>Calendar events</li>
          <li>Online meetings</li>
          <li>Documents</li>
          <li>Web activities</li>
          <li>Clocked activities</li>
          <li>Offline work captured through the Desktop Agent</li>
        </ul>
        <h3 className="mt-5 text-lg font-semibold">Suggested Entries</h3>
        <p className="mt-3 text-base leading-[1.35] text-[#666]">
          MIRA also creates Suggested Entries using AI. Based on the activities
          captured throughout the day, MIRA can:
        </p>
        <ul className="mt-1 list-disc pl-5 text-base leading-[1.35] text-[#666]">
          <li>Intelligently match activities to matters</li>
          <li>Group related activities together</li>
          <li>Generate draft narratives upon time entry creation</li>
        </ul>
        <div className="mt-5 flex gap-2">
          <button
            className="rounded-full bg-[#333] px-4 py-2 text-sm font-semibold text-white hover:bg-black"
            onClick={() => setIsTutorialOpen(true)}
            type="button"
          >
            Open Suggested Entries Tutorial
          </button>
          <button
            className="rounded-full border border-[#d9d9d9] bg-white px-4 py-2 text-sm text-[#333] hover:bg-neutral-100"
            onClick={onSkip}
            type="button"
          >
            Skip
          </button>
        </div>
        <div className="mt-4 rounded-lg border border-[#d9d9d9] bg-[#f5f5f5] p-4 text-sm text-[#666]">
          <p className="mb-3">
            <span aria-hidden="true" className="mr-2 font-semibold">
              ?
            </span>
            You may click the Timeline Tutorial icon in the upper-right corner
            of the Timeline Panel to access any time.
          </p>
          <img
            alt="Timeline Panel tutorial icon location"
            className="w-full max-w-[500px] object-contain"
            src={TIMELINE_TUTORIAL_ACCESS_IMAGE}
          />
        </div>
      </div>
      {isTutorialOpen && (
        <TutorialDialog onClose={() => setIsTutorialOpen(false)} />
      )}
    </>
  )
}

export default TimelineTipsStep
